import React from 'react';
import { StringField, StringFieldProps } from './StringField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { InputAdornment, IconButton } from '@material-ui/core';

export type PasswordFieldProps = StringFieldProps & {
    canShowPassword?: boolean
}

export function PasswordField ({ canShowPassword, ...props }: PasswordFieldProps) {
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(s => !s);
    };

    const handleMouseDownPassword = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
    };

    return (
        <StringField 
            {...props}
            type={ showPassword ? "text" : "password" }
            InputProps={
                canShowPassword !== false
                ? {
                endAdornment: <InputAdornment position="end">
                    <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                    >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                </InputAdornment>,
                }
                : props.InputProps
            }
        />
    )
}